import React from 'react'
import { NavLink } from 'react-router-dom'

const NotFound: React.FC = () => {
    return (
        <>
            <div className="container-fluid notFound">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="text-center">
                            <div className="col-md-10 col-md-offset-1 pull-right">
                                <img className="img-error" alt='not-found' src="https://bootdey.com/img/Content/fdfadfadsfadoh.png" />
                                <h2 className='mt-3'>404 Not Found</h2>
                                <p className='mt-3'>Sorry, an error has occured, Requested page not found!</p>
                                <div className="error-actions">
                                    <NavLink to="/" className="btn btn-primary btn-lg" data-cy="not-found-back-btn">
                                        <span className="glyphicon glyphicon-arrow-left" />
                                        Back Home
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotFound
